import { useEffect, useRef } from 'react'

const useHandleRef = (onResize: (resizeHeight: number) => void) => {
  const handleRef = useRef<HTMLElement>(null)

  useEffect(() => {
    // TODO: refactor using onDrag event.
    // Encountering weird bug with onDrag not triggering. Did a workaround here using mouse events.
    const handle = handleRef.current
    if (!handle) return

    let pressed = false
    handle.onmousedown = (evt) => {
      evt.preventDefault()
      evt.stopPropagation()
      pressed = true
      const onMouseMove = (evt) => {
        evt.preventDefault()
        evt.stopPropagation()
        if (pressed && onResize) onResize(document.body.clientHeight - evt.pageY)
      }
      const onMouseUp = () => {
        pressed = false
        document.removeEventListener('mousemove', onMouseMove)
      }
      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp, { once: true })
    }
  }, [handleRef.current])

  return handleRef
}
export default useHandleRef
